import {Component, Inject, Input, Output, EventEmitter} from '@angular/core';
import {WindowRefService} from "../../../services/window-ref.service";
import {APP_CONFIG, AppConfig} from "../../../config/app.config";

@Component({
  selector: 'app-avia-not-found',
  standalone: true,
  templateUrl: './avia-not-found.component.html',
  styleUrl: './avia-not-found.component.scss',
})
export class AviaNotFoundComponent {
  @Input() filtered = false;
  @Output() changeFilters = new EventEmitter<void>();

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private window: WindowRefService) {

  }

  ngOnInit() {

  }

  translates = this.appConfig.translates.notFound;

  goToFindForm() {
    if (this.filtered) {
      this.changeFilters.emit();
      return;
    }
    this.window.nativeWindow.location.href = '/new/findavia';
  }
}
